module.exports = {
  IsDev: false,

  ROOT_URL:  process.env.REACT_APP_ROOT_URL,
  API_URL: process.env.REACT_APP_API_URL,
  SOCKET_URL: 'http://soc.winee-sports.com',
  MaleUrl: '/assets/image/z_male.png',
  PAGECOUNT: 15,
  AUTH_TIME: 180,

  KAKAO_JS_KEY: 'c109111a919b1ba13384ef361e040321',
  KAKAO_REST_API: 'f1ca3c451fd4b92c0e5b8679d67d46ef',
  KAKAO_REDIRECT_URI: 'http://winee-sports.com/login',
  KAKAO_SECRET: 'VRAQES4CFijZ5BsV2Pb8lFc7JWhaBHEl',

  GOOGLE_CLIENT_ID: '14114021147-p0k96e240kougqvrhkanm5ti0k5ceqbm.apps.googleusercontent.com',

  NAVER_CLIENT_ID: '1WexYHm2uUhRFKQaWj9T',
  NAVER_SECRET: 'yMBOKaiZXN',
  NAVER_REDIRECT_URI: 'http://winee-sports.com/login',

  PAY_BANK: '기업은행',
  PAY_ACCOUNT: '236-108853-04-017',
  PAY_DEPOSITOR: '주식회사 위니네트워크',

  IMP_CODE: 'imp88380717',
  IMP_PG: 'danal',
  IMP_CPID: 'B010008560', //A010002002

  optionChart: {
    chart: {
      // height: 130,
      type: 'area',
      offsetY: -22,
      shadow: {
        enabled: false,
        color: '#2d353c',
        top: 18,
        left: 7,
        blur: 10,
        opacity: 1
      },
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      },
    },
    dataLabels: {
      enabled: true,
      distributed: false,
      textAnchor: 'middle',
      offsetY: 8,
      style: {
        colors: ['#3e414a'],
        fontSize: '13'
      },
      background: {
        enabled: false
      },
      formatter: function (val) {
        return val + '%'
      }
    },
    stroke: {
      curve: 'smooth',
      width: 2
    },
    colors: ['#0f4c81'],
    markers: {
      size: 3,
      strokeColor: 'transparent'
    },
    yaxis: {
      min: 0,
      // max: 80,
      labels: {
        show: false,
        style: {
          fontSize: '10',
          colors: '#3a3335',
        },
        // offsetY: 12
      },
    },
    grid: {
      show: false,
      borderColor: '#e4e9f2',
      yaxis: {
        lines: {
          show: true,
          offsetX: 10,
          offsetY: 10
        }
      },
    },
    fill: {
      gradient: {
        gradientToColors: ['#ffffff', '#bfd0dd']
      }
    }
  },
  optionsXaxisAxisBorder: {
    show: true,
    color: '#878c91',
    height: 1,
    width: '100%',
    offsetX: 0,
    offsetY: 12
  },
  optionsXaxisAxisTicks: {
    show: true,
    borderType: 'solid',
    color: '#878c91',
    height: 0,
    offsetX: 0,
    offsetY: 0
  },
  optionsXaxisLabels: {
    style: {
      fontSize: '10',
      colors: '#878c91',
    },
    offsetY: -3,
  },

  HEADER: {
    AUTH_TOKEN: 'token',
    CONTENT_TYPE: {
      NAME: 'Content-Type',
      JSON: 'application/json',
      FILE: 'multipart/form-data',
      FORM: 'application/x-www-form-urlencoded'
    },
    LANG: 'Accept-Language',
  },

  //. 각종 시간/일자 포맷
  FORMAT: {
    DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
    DATE_TIME2: 'YYYY-MM-DD HH:mm',
    DATE: 'YYYY-MM-DD',
    TIME: 'HH:mm:ss',
    TIME2: 'HH:mm',
    MONTH: 'YYYY-MM',
    YEAR: 'YYYY'
  },

  //. 응답코드
  RESULT_CODE: {
    SUCCESS: 200,         //. 정상
    ERROR: 401,           //. api 내부 오류
    EMPTY_PARAM: 403,     //. 요청파라미터 누락
    TOKEN_EXPIRED: 404,   //. 토큰 기한 만료
    WRONG_PWD: 506,       //. 아이디/비밀번호 틀림
    USER_WITHDRAW: 516,   //. 탈퇴회원
  },

  //. 사용자 상태코드
  USER_STATUS: {
    LEAVE: -3,        //. 탈퇴
    BLOCK: -2,        //. 영구정지
    HOLD: -1,         //. 홀딩
    PENDING: 0,       //. 심사대기
    NORMAL: 1,        //. 정상
  },

  //. 성별
  GENDER: {
    MALE: 'M',
    FEMALE: 'F'
  },

  //. 상태코드
  STATUS: {
    PENDING: 0,         //. 대기
    NORMAL: 1,          //. 정상
    REJECT: 2,          //. 반려
    DELETED: -1,        //. 삭제
    FINISH: 2,          //. 완료
    CANCEL: 2,          //. 취소
    REAPPLY: 3,         //. 재심요청
    YES: 'Y',
    NO: 'N'
  },
}
